import React from "react";
import { ArrowLeft, BookOpen, Home } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import bannerImg from "../assets/images/new-home-page-img.png";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Helmet>
        <title>Page Not Found | TheOmSaga</title>
        <meta
          name="description"
          content="The page you requested could not be found on TheOmSaga."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="not-found-hero">
        <img
          src={bannerImg}
          className="not-found-hero-image"
          alt=""
          aria-hidden="true"
        />
        <div className="not-found-hero-overlay" />

        <div className="not-found-content">
          <span className="not-found-code">404</span>
          <h1>Page Not Found</h1>
          <p>
            The page you are looking for may have moved or no longer exists.
            Let us guide you back to TheOmSaga.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="not-found-primary-link">
              <Home size={18} aria-hidden="true" />
              Go to Home
            </Link>
            <Link to="/stories" className="not-found-secondary-link">
              <BookOpen size={18} aria-hidden="true" />
              Explore Stories
            </Link>
          </div>

          <button
            type="button"
            className="not-found-back-button"
            onClick={() => window.history.back()}
          >
            <ArrowLeft size={16} aria-hidden="true" />
            Go back
          </button>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
